(() => {
  const modal = document.querySelector(".addon-modal");
  if (!modal) return;

  const panel = modal.querySelector(".addon-modal__panel");

  let lastFocus = null;

  function lockScroll(lock) {
    document.documentElement.classList.toggle("addon-modal--lock", lock);
    document.body.classList.toggle("addon-modal--lock", lock);
  }

  function openModal() {
    lastFocus = document.activeElement;
    modal.hidden = false;
    requestAnimationFrame(() => modal.classList.add("is-open"));
    lockScroll(true);
  }

  function closeModal() {
    modal.classList.remove("is-open");
    lockScroll(false);
    setTimeout(() => {
      modal.hidden = true;
      panel.innerHTML = '<div class="addon-modal__loading"></div>';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }, 220);
  }

  async function loadContent(url) {
    panel.innerHTML = '<div class="addon-modal__loading"></div>';
    const res = await fetch(url, { headers: { Accept: "text/html" } });
    const html = await res.text();
    panel.innerHTML = html;

    // wire close button
    const closeBtn = panel.querySelector(".addon-modal__close");
    closeBtn?.addEventListener("click", closeModal);

    // basic slider
const slider = panel.querySelector("[data-slider]");
if (slider) {
  const track = slider.querySelector("[data-track]");
  const dots = Array.from(slider.querySelectorAll("[data-dot]"));
  const prev = slider.querySelector("[data-prev]");
  const next = slider.querySelector("[data-next]");
  let index = 0;

  function go(i) {
    index = Math.max(0, Math.min(i, dots.length - 1));
    track.style.transform = `translateX(${-index * 100}%)`;
    dots.forEach((d, di) => d.classList.toggle("is-active", di === index));
    if (prev) prev.disabled = index === 0;
    if (next) next.disabled = index === dots.length - 1;
  }

  prev?.addEventListener("click", () => go(index - 1));
  next?.addEventListener("click", () => go(index + 1));
  dots.forEach((d) => d.addEventListener("click", () => go(parseInt(d.dataset.dot, 10))));
  go(0);
}

  }

  document.addEventListener("click", async (e) => {
    const btn = e.target.closest("[data-addon-modal]");
    if (btn) {
      e.preventDefault();
      const url = btn.getAttribute("data-addon-url");
      if (!url) return;
      openModal();
      await loadContent(url);
      return;
    }

    if (e.target.closest("[data-close]")) {
      closeModal();
    }
  });

  document.addEventListener("keydown", (e) => {
    if (!modal.hidden && e.key === "Escape") closeModal();
  });
})();
